import { MrbBaseViewStore } from "mrb/core";

class NotFoundViewStore extends MrbBaseViewStore {
    constructor(rootStore) {
        super(rootStore);
    }

    onClickHome = () => {
        this.rootStore.routerStore.goToDefaultRoute();
    };
}

export default NotFoundViewStore;
